import { ForwardedRef, forwardRef, RefAttributes } from 'react';
import * as Checkbox from '@radix-ui/react-checkbox';
import { CheckboxProps } from '@radix-ui/react-checkbox';
import classNames from 'classnames';

import { icon_tick_small } from '@gn-audio/icons';

import { JabraIcon } from '../JabraIcon/JabraIcon';

const CustomCheckbox = forwardRef(
  (
    { className, ...rest }: CheckboxProps & RefAttributes<HTMLButtonElement>,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <Checkbox.Root
        ref={ref}
        className={classNames(
          'flex h-[1.125rem] w-[1.125rem] basis-[1.125rem] items-center justify-center rounded border border-gray-700 text-gray-700 focus-visible:outline-none focus-visible:ring-2',
          className
        )}
        {...rest}
      >
        <Checkbox.Indicator>
          <JabraIcon viewBox="0 0 12 12" className="h-3 w-3" Icon={icon_tick_small} />
        </Checkbox.Indicator>
      </Checkbox.Root>
    );
  }
);

CustomCheckbox.displayName = 'JabraCheckbox';
export const JabraCheckbox = CustomCheckbox;
